<template>
  <div>
    <div class='forms'>
      <div class='cards'>
        <div class='card full'>
          <div class='inputs'>
            <div class='input'>
              <label>I want to pay</label>
              <button class='red_btn'>Annual Payment - $149</button>
            </div>
            <div class='input'>
              <label>Last Name</label>
              <input type="text" v-model="user.lastName">
            </div>
            <div class='input'>
              <label>Email Address</label>
              <input type="text" v-model="user.email">
            </div>
            <div class='input'>
              <label>Phone Number</label>
              <input type="tel" v-model="user.phone">
            </div>
            <div class='input full'>
              <label>Notes</label>
              <textarea v-model='user.notes'></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click='verify()' class='btn finish'>SAVE</button>
  </div>
</template>

<script>
  export default {
    name: 'info',
    data() {
      return {
        user: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          notes: ''
        },
        step: 1,

      }
    },
    created() {
      console.log(this.$parent.step);
    },
    methods: {
      verify() {
        let send = true;
        if (this.user.firstName.length < 1) {
          send = false;
          alert('Please enter a first name')
        }
        if (this.user.lastName.length < 1 && send) {
          send = false;
          alert('Please enter a last name')
        }
        if (this.user.phone.length < 1 && send) {
          send = false
          alert('Please enter a phone number')
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.user.email.toLowerCase()) && send) {
          send = false;
          alert('Please enter a valid email address')
        }
        if (send) {
          this.next()
        }
      },
      next(name, data){
        let vm = this;
        this[name] = data;
        let num = this.step;
        this.step = null;
        setTimeout(function(){
          vm.$parent.step = num+1;
          vm.submitPurchase()
        }, 500);
      },
      submitPurchase() {
        let vm = this;
        vm.$emit('assignUserInfo', vm.user)
        vm.$parent.popup = true;
      }
    }
  }
</script>

<style scoped></style>
